import axios from "axios";

import { GenericCaseType, GenericCaseTypeCreateModel } from "./models";

const url = "/api/genericCaseType";

const getAll = async () => (await axios.get<GenericCaseType[]>(url)).data;

const get = async (id: string) => (await axios.get<GenericCaseType>(`${url}/${id}`)).data;

const create = async (genericCaseType: GenericCaseTypeCreateModel) => (await axios.post<GenericCaseType>(url, genericCaseType)).data;

const update = async (genericCaseType: GenericCaseType) => (await axios.put<GenericCaseType>(`${url}/${genericCaseType.id}`, genericCaseType)).data;

export const GenericCaseTypeApi = { getAll, get, create, update };
